import { Box } from "@material-ui/core";
import { Grid, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../App.css";

import { ReactComponent as InvitationIconWhite } from "../../assets/DashBoardTableIcons/InvitationIconWhite.svg";
import { ReactComponent as PreRegistration } from "../../assets/DashBoardTableIcons/PreRegistration.svg";
import { ReactComponent as WalkInRegistrationIcon } from "../../assets/DashBoardTableIcons/RegistrationIconWalkIn.svg";
import { ReactComponent as SelfRegistration } from "../../assets/DashBoardTableIcons/SelfRegistration.svg";

const CustomStyleStatus = ({
  row,
  visitMode,
  darkMode = false,
  icon = true,
}) => {
  const { t } = useTranslation();

  const iconContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "15px",
  };

  const StatusTab = ({ status }) => {
    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Grid style={{ flex: "0 0 150px" }}>
          <Typography style={{ padding: "4px" }}>{status}</Typography>
        </Grid>
      </Box>
    );
  };

  const renderVisitModeIcon = () => {
    if (!icon) {
      return null;
    }

    const iconStyle = {
      fill: darkMode ? "#fff" : "#474a4e",
    };

    switch (visitMode) {
      case "INVITATION":
        return (
          <span style={iconContainerStyle}>
            <Tooltip title="Invitation">
              <InvitationIconWhite style={iconStyle} />
            </Tooltip>
          </span>
        );

      case "WALKIN_REGISTARTION":
      case "WALKIN_REGISTARTION_KIOSK":
        return (
          <span style={iconContainerStyle}>
            <Tooltip title="Walk-In Registration">
              <WalkInRegistrationIcon style={iconStyle} />
            </Tooltip>
          </span>
        );

      case "SELF_REGISTARTION":
        return (
          <span style={iconContainerStyle}>
            <Tooltip title="Self Registration">
              <SelfRegistration style={iconStyle} />
            </Tooltip>
          </span>
        );

      case "PRE_REGISTRATION":
        return (
          <span style={iconContainerStyle}>
            <Tooltip title="Pre Registration">
              <PreRegistration style={iconStyle} />
            </Tooltip>
          </span>
        );

      default:
        return null;
    }
  };

  const statusConfig = {
    SCHEDULED: {
      color: "#EDBD37",
      backgroundColor: "#EDBD3726",
      label: t("VISSTATUS011"),
    },

    RESCHEDULED: {
      color: "#EDBD37",
      backgroundColor: "#EDBD3726",
      label: t("RESCHEDULED"),
    },

    Rescheduled: {
      color: "#EDBD37",
      backgroundColor: "#EDBD3726",
      label: "Rescheduled",
    },

    COMPLETED: {
      color: "#008000",
      backgroundColor: "#ccffcc",
      label: t("VISSTATUS020"),
    },

    EXPIRED: {
      color: "#E3393C",
      backgroundColor: "#E3393C1A",
      label: t("EXPIRED"),
    },

    PENDING_ARRIVAL: {
      color: "#E16B05",
      backgroundColor: "#E16B0526",
      label: t("Pending Arrival"),
    },

    TIME_EXPIRED: {
      color: "#E3393C",
      backgroundColor: "#E3393C1A",
      label: t("EXPIRED"),
    },

    LOGGED: {
      color: "#008000",
      backgroundColor: "#ccffcc",
      label: t("VISSTATUS021"),
    },

    APPROVED: {
      color: "#36C96D",
      backgroundColor: "#36C96D26",
      label: t("VISSTATUS015"),
    },

    CONFIRMED: {
      color: "#A6C212",
      backgroundColor: "#A6C21226",
      label: t("VISSTATUS012"),
    },

    CHECKED_OUT: {
      color: "#03ACBF",
      backgroundColor: "#03ACBF26",
      label: t("VISSTATUS018"),
    },

    CANCELLED: {
      color: "#E3393C",
      backgroundColor: "#E3393C26",
      label: t("VISSTATUS013"),
    },

    CHECKED_IN: {
      color: "#287ADC",
      backgroundColor: "#287ADC26",
      label: t("VISSTATUS017"),
    },

    INITIATED_FOR_BLOCKED: {
      color: "#D53033",
      backgroundColor: "#D5303326",
      label:
        process.env.REACT_APP_ENVIRONMENT === "USA"
          ? "Blocklist Initiated"
          : "Block Initiated",
    },

    BLOCKED: {
      color: "#D53033",
      backgroundColor: "#D5303326",
      label:
        process.env.REACT_APP_ENVIRONMENT === "USA"
          ? t("VISSTATUS019")
          : "Blocked",
    },

    REJECTED: {
      color: "#E3393C",
      backgroundColor: "#E3393C26",
      label: t("VISSTATUS014"),
    },

    MISSED: {
      color: "#ED8637",
      backgroundColor: "#ED863726",
      label: t("VISSTATUS016"),
    },
  };

  const config = statusConfig[row];

  if (!config) {
    return (
      <Box>
        <div
          style={{
            color: "#141413",
            borderColor: "#141413",
            opacity: 1,
          }}
        >
          {row}
        </div>
      </Box>
    );
  }

  return (
    <Grid display="flex" alignItems="center">
      <span
        style={{
          color: config.color,
          backgroundColor: config.backgroundColor,
          opacity: 1,
          borderRadius: "7px",
        }}
      >
        <StatusTab status={config.label} />
      </span>

      {renderVisitModeIcon()}
    </Grid>
  );
};

export default CustomStyleStatus;
